import React, { useContext, useMemo, useState } from "react";
import { Card } from "primereact/card";
import { Chip } from "primereact/chip";
import { Button } from "primereact/button";
import { FarmContext } from "../../contexts/FarmContext";
import { Link, useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { dateFormat } from "../../utils/date";
import { DefaultCardLogo } from "./DefaultCardLogo";
import ActionDialog from "./ActionDialog";
import { Integrator } from "./Services/Integrator";
import { Common } from "./Services/Common";
import { LocationIcon } from "./Icons/LocationIcon";

/**
 * @param {{ connection: typeof import("./data").availableConnections[0]}} props
 *
*/
const ConnectionCard = ({ connection, setSelectedCategories, isEnabledCard }) => {
    const [{ dataFarm }, _] = useContext(FarmContext);
    const { t, i18n } = useTranslation();
    const { farmId, canAutorizarApi } = useOutletContext() || {};
    const [actionDialogState, setActionDialogState] = useState({ visible: false });
    const WEENAT_ID = 1;
    const DAVIS_ID = 2;
    const AUTOGEST_ID = 9;

    const connectionIdentifier = useMemo(() => {
        if (!connection || !isEnabledCard) return "";
        return Common.resolveConnectionIdentifier(connection, t)?.label;
    }, [connection, isEnabledCard, t]);

    const Header = () => {
        return (
            <div className='card-header' style={{ backgroundColor: connection.logo ? "#FFF" : "#F3F3F3" }}>
                {connection.logo ? (
                    <img
                        className="background-img"
                        src={`https://static.dropcontrol.com/${connection.logo}`}
                        alt=""
                    />
                ) : (<DefaultCardLogo />)}
                <Chip
                    className='mkt-chip'
                    style={{ borderColor: "#1E84A6", color: "#1E84A6" }}
                    label={t(`marketplace.products.${connection.tipo}`)}
                />

                {
                    connection.marketplace_servicio_id===AUTOGEST_ID && isEnabledCard?
                        <span style={{ paddingLeft:"130px", fontSize:"0.8rem", fontStyle:"oblique", zIndex: 1 }}>
                            { t("sass.autogestionado") }
                        </span>
                        :null
                }
            </div>

        );
    };
    const CompanyInfo = () => {
        return (
            <>
                <div className='service-title' data-testid="service-title">
                    {connection.marketplace_servicio_id===AUTOGEST_ID && isEnabledCard?connection.connection_data?.nombre:connection.nombre_servicio}
                </div>
                <div className='p-card-subtitle'>
                    {connection.link ?
                        <a title='Service Link' href={connection.link} target='_blank' rel='noreferrer' className='company-name'>
                            {connection.nombre_compania ? connection.nombre_compania : ""}
                        </a>
                        : <div className="company-name">{connection.nombre_compania ? connection.nombre_compania : ""}</div>}
                    {!isEnabledCard && (
                        <div className='mkt-company-location'>
                            <span className='icon'>
                                <LocationIcon />
                            </span>
                            <span style={{ verticalAlign: "middle" }}>
                                { connection.paises ? connection.paises : t("marketplace.global") }
                            </span>
                        </div>
                    )}
                </div>
            </>
        );
    };

    const CardDescription = () => {
        return !isEnabledCard ? (
            <>
                <div className='description'>
                    {connection.descripcion}
                </div>
                <div className='view-details'>
                    <Link style={{ textDecoration: "none" }} to={`/farms/marketplace/${connection.marketplace_servicio_id}?farm=${farmId}`} >
                        {t("marketplace.viewDetails")}
                    </Link>
                </div>
            </>
        ) : (
            <>
                <div className='enabled-description'>
                    <div className='description-item'>
                        <div className='item-title' title={t("marketplace.enablingDate")}>{t("marketplace.enablingDate")}</div>
                        <div className='item-content' title={connection.connection_data?.created_at ? dateFormat(connection.connection_data?.created_at, t, i18n.language, dataFarm.huso_horario,true,true) : "-"}>
                            {connection.connection_data?.created_at ? dateFormat(connection.connection_data?.created_at, t, i18n.language, dataFarm.huso_horario,true,true) : "-"}
                        </div>
                    </div>
                    <div className='description-item'>
                        <div className='item-title' title={t("marketplace.productState")}>{t("marketplace.productState")}</div>
                        <div className='item-content' title={t("marketplace.active")}>{t("marketplace.active")}</div>
                    </div>
                    {Boolean(connectionIdentifier) && connection.marketplace_servicio_id !== AUTOGEST_ID && (
                        <div className='description-item'>
                            <div className='item-title' title={t("forms.identificador")}>{t("forms.identificador")}</div>
                            <div className='item-content' title={connectionIdentifier}>{connectionIdentifier}</div>
                        </div>
                    )}

                </div>
            </>
        );
    };

    const ActionButton = () => {
        return !isEnabledCard ? (
            <div className='mkt-button mkt-btn-enable'>
                {connection.disabled_state?.disabled ? (
                    <Button
                        label={t("forms.habilitar")}
                        disabled
                        tooltip={connection.disabled_state.reason ?? undefined}
                        tooltipOptions={{ showOnDisabled: true, position: "top", style: { fontSize: "12px", fontFamily: "Montserrat" } }}
                    />
                ) : (
                    <Link
                        to={`/farms/marketplace/${connection.marketplace_servicio_id}?farm=${farmId}`}
                        style={{ textDecoration: "none"  }}
                    >
                        <Button
                            label={t("forms.habilitar")}
                        />
                    </Link>
                )}
            </div>
        ) : (

            <div className='mkt-button mkt-btn-manage'>
                {!canAutorizarApi?
                    <Button
                        label={t("marketplace.manage")}
                        disabled
                        tooltip={t("forms.toastError401")}
                        tooltipOptions={{ showOnDisabled: true, position: "top", style: { fontSize: "12px", fontFamily: "Montserrat" } }}
                    />
                    :connection.connection_data?.is_old ? (
                        <>
                            <Button style={{ textDecoration: "none" }} label={t("marketplace.manage")} onClick={() => {
                                setActionDialogState(Integrator.oldIntegratorDialog(t, connection, i18n));
                            }}
                            />
                        </>
                    ) : (
                        connection?.marketplace_servicio_id==AUTOGEST_ID?
                            <>
                                <Link style={{ textDecoration: "none" }} to={`/farms/marketplace/connected/${connection.connection_id}?farm=${farmId}`} >
                                    <Button label={t("marketplace.manage")} />
                                </Link>
                                <div className='enabled' title={t("marketplace.accessUsed",{"access":connection.is_old?Integrator.resolveOldIntegratorAccessType(connection, t):t(`sass.tipoUsuario.${connection.connection_data?.tipousuario_id}`)})}>
                                    <span>
                                        {t("marketplace.accessUsed",{"access":connection.is_old?Integrator.resolveOldIntegratorAccessType(connection, t):t(`sass.tipoUsuario.${connection.connection_data?.tipousuario_id}`)})}
                                    </span>
                                </div>
                            </>:
                            <>
                                <Link style={{ textDecoration: "none" }} to={`/farms/marketplace/connected/${connection.connection_id}?farm=${farmId}`} >
                                    <Button label={t("marketplace.manage")} />
                                </Link>
                            </>
                    )}
            </div>
        );
    };

    const Content = () => {
        return (
            <>
                <CardDescription />
            </>
        );
    };

    const Footer = () => {
        return (
            <>
                <div className='categories'>
                    { connection.categorias.map(category => {
                        return (
                            <span key={`category_${category}`} className='category' title={t(`marketplace.categories.${category}`)} onClick={() => {
                                setSelectedCategories([category]);
                            }}
                            >
                                #{t(`marketplace.categories.${category}`)}
                            </span>
                        );
                    })}
                </div>
                {!isEnabledCard && (
                    <div className='connection-info'>
                        <div className='provider-price' title={`${t("marketplace.costoProveedor")}: US$${connection.costo_proveedor}`}>
                            {
                                connection.costo_proveedor?
                                    connection.costo_proveedor==="limitedFree"?
                                        t("marketplace.limitedFreeCost")
                                        :
                                        connection.costo_proveedor==="FREE"?
                                            null
                                            :`${t("marketplace.costoProveedor")}: US$${connection.costo_proveedor}`
                                    :null
                            }
                        </div>
                    </div>
                )}
                <ActionButton />
                <div className='enabled' title={`${connection?.childs?.length} ${t("marketplace.habilitados")}`}>
                    {Boolean(connection?.childs?.length) && !isEnabledCard && (
                        <>
                            <span>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.2669 5.00003C14.8003 5.53337 14.8003 6.40003 14.2669 6.8667L12.4003 8.73337L7.20026 3.53337L9.06693 1.6667C9.60026 1.13337 10.4669 1.13337 10.9336 1.6667L12.1336 2.8667L14.1336 0.866699L15.0669 1.80003L13.0669 3.80003L14.2669 5.00003ZM10.4003 8.8667L9.46693 7.93337L7.60026 9.80003L6.20026 8.40003L8.06693 6.53337L7.13359 5.60003L5.26693 7.4667L4.26693 6.53337L2.40026 8.40003C1.86693 8.93337 1.86693 9.80003 2.40026 10.2667L3.60026 11.4667L0.933594 14.1334L1.86693 15.0667L4.53359 12.4L5.73359 13.6C6.26693 14.1334 7.13359 14.1334 7.60026 13.6L9.46693 11.7334L8.5336 10.8L10.4003 8.8667Z" fill="#579C27" />
                                </svg>
                            </span>
                            <span>
                                {connection.tipo_formulario === "SEAT" ? connection.childs[0].seat_cant : connection?.childs?.length}
                            </span>
                            <span >
                                {t("marketplace.habilitados")}
                            </span>
                        </>
                    )}
                </div>
            </>
        );
    };

    return (
        <>
            {actionDialogState?.visible && (
                <ActionDialog
                    dialogState={actionDialogState}
                    setDialogState={setActionDialogState}
                />
            )}
            <Card pt={{
                content: {
                    style: { height: isEnabledCard ? "72px" : "54px" }
                }
            }} title={CompanyInfo} header={Header} footer={Footer} className="mkt-card"
            >
                <Content />
            </Card>
        </>

    );
};

export default ConnectionCard;
